import React from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { createTypographyHelper } from "../../../../utils/typography";
import moment from "moment";
import { ClockIcon } from "../../../../components/icons";

const dateTimeContainer = ({ className, children }) => {
  return (
    <div className="custom-datepicker-container">
      <div className={className}>{children}</div>
    </div>
  );
};

const PickupTimePicker = ({
  value,
  onChange,
}) => {
  const { i18n, t } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const lang = i18n.language.toUpperCase();

  return (
    <div className="tw:flex tw:flex-col">
      <div className={`tw:mb-2 tw:text-[#8d8d8d] ${getTypographyClass(13)}`}>
        {t("editBooking.BookingEditPage.basicInformation.pickupTime")}
      </div>
      <DatePicker
        locale={lang === "EN" || lang === "en" ? "en" : "ja"}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={5}
        timeCaption={t("Pick.Up.Time")}
        timeFormat="HH:mm"
        dateFormat="HH:mm"
        calendarContainer={dateTimeContainer}
        // onChange={onChange}
        onChange={(date, event) => {
          if (event == undefined) {
            var formatedDate = date.toLocaleDateString("sv-SE", {
              hour: "2-digit",
              minute: "2-digit",
            });
            var tge = moment(formatedDate);
            onChange(tge.format("HH:mm"))
          }
        }}
        customInput={
          <div className="tw:relative">
            <input
              type="text"
              name="pickuptime"
              maxLength={8}
              autoComplete="off"
              readOnly={true}
              className={`tw:h-[50px] tw:w-full tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:pl-[50px] tw:pr-[14px] tw:outline-none tw:focus:border-[#282828] ${getTypographyClass(14)} tw:font-hanken-grotesk tw:!text-[#282828]`}
              placeholder="Pick-up time"
              aria-label="Pick-up time"
              value={value}
            />
            <span className="tw:absolute tw:left-[14px] tw:top-1/2 tw:-translate-y-1/2">
              <ClockIcon aria-label="clock" role="img" />
            </span>
          </div>
        }
      />
    </div>
  );
};

export default PickupTimePicker;
